import type { TopStrategyTunerPlugin } from "../../TopStrategyTunerPlugin";

export function applyStickyTopBoxadIfFandomDesktop(
  currentApp: string,
  topStrategyTunerPlugin: TopStrategyTunerPlugin,
): Promise<void> | void {
  if (currentApp !== "fandomdesktop") return;

  return import("./TopBoxadHandler")
    .then(({ TopBoxadHandler }) => {
      new TopBoxadHandler().applySticky(topStrategyTunerPlugin);
    })
    .catch((error) => {
      console.error("Failed to load TopBoxadHandler:", error);
    });
}
